import React from 'react';
//import GoogleMapReact from 'google-map-react';
//import { storyblokEditable } from 'gatsby-source-storyblok';
//import GoogleMapMarker from '../content/maps/google_map_marker';
//import { useHotelPages } from '../../hooks/useHotelPages';

const DestinationMap = ({ blok, hotels }) => {
  return <></>;

  /*
  const hotelPages = useHotelPages(blok.hotels);

  let items = [];

  if (hotelPages) {
    items = hotels.reduce((hotelsCombined, hotel) => {
      const matchingHotelPage = hotelPages.find(
        (hotelPage) => hotelPage.field_hotel_id_string === hotel.id,
      );
      if (matchingHotelPage) {
        const combo = { ...hotel, ...matchingHotelPage };
        hotelsCombined.push(combo);
      }
      return hotelsCombined;
    }, []);

    items.sort((a, b) => {
      const indexA = hotelPages.findIndex(
        (hotelPage) => hotelPage.field_hotel_id_string === a.id,
      );
      const indexB = hotelPages.findIndex(
        (hotelPage) => hotelPage.field_hotel_id_string === b.id,
      );
      return indexA - indexB;
    });
  }

  const center = {
    // Default center of the map. If not set, it will be Gothenburg
    lat: parseFloat(blok.destination_latitude) || 57.69721634340465,
    lng: parseFloat(blok.destination_longitude) || 11.976116999692321,
  };
  const zoom = parseInt(blok.zoom_level) || 15;

  return (
    // Important! Always set the container height explicitly
    <div
      style={{
        height: blok.height || '70vh',
        width: blok.width || '100%',
        overflow: 'hidden',
      }}
      className="col-span-12 rounded mt-12"
      {...storyblokEditable(blok)}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_API_KEY }}
        center={center}
        zoom={zoom}
        mapContainerStyle="rounded"
      >
        {items.map((hotel) => (
          <GoogleMapMarker
            lat={hotel.geoCoordinateLat}
            lng={hotel.geoCoordinateLong}
            text={hotel.name}
            key={hotel.uuid}
            hotel={hotel}
          />
        ))}
      </GoogleMapReact>
    </div>
  );*/
};

export default DestinationMap;
